<h1 mat-dialog-title class="heading text-primary">Settings</h1>
<div mat-dialog-content>
  <div class="row m-0 p-0 user-setting-container">
    <div class="col-12 m-0 p-0">
      <mobi-office-lib-tabs [tabs]="tabs" (tabChange)="onTabChange()" [(selectedTab)]="selectedTab" tabStyle="bordered"></mobi-office-lib-tabs>
    </div>
    @if (errorMessages.length) {
      <div class="col-12 py-2" AsteriskMessage [messageList]="errorMessages"></div>
    }
    @if (selectedTab === "My Details") {
      <div class="col-12 m-0 pb-3">
        <div class="row m-0 p-0">
          <div class="col-md-6 col-12 mt-2">
            <mobi-office-lib-file-upload
              [isMultipleUpload]="false"
              [allowDelete]="USER_PROFILE_CONFIGURATION.canChangeProfile"
              label="Upload Profile"
              [(masterFiles)]="userLogo"
              [isRequired]="true"></mobi-office-lib-file-upload>
          </div>
          <div class="col-12"></div>
          <div class="col-xl-6 col-12 mt-2">
            <mobi-office-lib-input-field
              [(model)]="FirstName"
              [readOnly]="!USER_PROFILE_CONFIGURATION.canChangeName"
              label="Name"
              placeholder="Name"
              [maxLength]="'120'"
              [isRequired]="true"
              type="text"></mobi-office-lib-input-field>
          </div>
          <!-- <div class="col-xl-6 col-12 mt-2">
            <mobi-office-lib-input-field
              [(model)]="LastName"
              [readOnly]="!USER_PROFILE_CONFIGURATION.canChangeName"
              label="Last Name"
              placeholder="Last Name"
              [maxLength]="'120'"
              [isRequired]="true"
              type="text"></mobi-office-lib-input-field>
          </div> -->
          <div class="col-xl-6 col-12 mt-2">
            <mobi-office-lib-input-field
              [(model)]="Username"
              [readOnly]="!USER_PROFILE_CONFIGURATION.canChangeUserName"
              label="Username"
              placeholder="Username"
              [maxLength]="'120'"
              [isRequired]="true"
              type="text"></mobi-office-lib-input-field>
          </div>
          <div class="col-xl-6 col-12 mt-2">
            <mobi-office-lib-input-field
              [(model)]="EmailID"
              [readOnly]="!USER_PROFILE_CONFIGURATION.canChangeEmail"
              label="EmailID"
              placeholder="EmailID"
              [maxLength]="'120'"
              [isRequired]="true"
              type="text"></mobi-office-lib-input-field>
          </div>
          <div class="col-xl-6 col-12 mt-2">
            <mobi-office-lib-drop-down
              label="Country"
              [readonly]="!USER_PROFILE_CONFIGURATION.canChangePhoneNumber"
              [clearable]="false"
              [isRequired]="true"
              placeholder="Select Country"
              [(model)]="selectedCountry"
              [optionList]="countryList"
              bindValue="value"
              bindLabel="label">
            </mobi-office-lib-drop-down>
          </div>
          <div class="col-xl-6 col-12 mt-2">
            <mobi-office-lib-input-field
              [(model)]="Phone"
              label="Phone"
              placeholder="Phone"
              [readOnly]="!USER_PROFILE_CONFIGURATION.canChangePhoneNumber"
              [maxLength]="'20'"
              [isRequired]="true"
              type="text"></mobi-office-lib-input-field>
          </div>
          <div class="col-9 mt-2">
            <mobi-office-lib-input-field
              [readOnly]="true"
              type="text"
              [maxLength]="'255'"
              [(model)]="UserApiKey"
              label="API Key"
              [isRequired]="false"
              placeholder="User API Key"></mobi-office-lib-input-field>
          </div>
          <div class="col-3 mt-2 d-flex align-items-center pt-4">
            <button matRipple class="btn-sm-filled-primary" (click)="onGenerateApiKey()">Generate</button>
          </div>
          @if ((applicationInfo$ | async)?.length) {
            <div class="col-12 mt-2">
              <label for="" class="form-group-label fs-14 text-dark">Application</label>
              <div class="d-flex flex-column gap-2">
                @for (item of applicationInfo$ | async; track $index) {
                  <div class="d-flex align-items-center flex-wrap gap-1">
                    <div>
                      <span class="fs-12 fw-bold text-dark">{{ item.ApplicationTitle }}</span>
                      :
                    </div>
                    <div class="d-flex gap-2">
                      @for (role of item.RolesList; track $index) {
                        <mobi-office-lib-chips [chipText]="role.RoleName" [chipSize]="'small'"></mobi-office-lib-chips>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <div class="col-12 mt-3 d-flex justify-content-end">
            <button class="btn-sm-filled-primary" matRipple (click)="onUpdateProfile()">Update</button>
          </div>
        </div>
      </div>
    } @else {
      <div class="col-12 m-0 pb-3">
        <div class="row m-0 p-0">
          @if (!USER_PROFILE_CONFIGURATION.canChangePassword) {
            <div class="col-12 d-flex justify-content-center align-items-center">
              <span class="text-danger fs-14">You don't have rights to change the password</span>
            </div>
          }
          <div class="col-12 mt-2">
            <mobi-office-lib-input-field
              [(model)]="currentPassword"
              label="Current Password"
              [readOnly]="!USER_PROFILE_CONFIGURATION.canChangePassword"
              placeholder="Current Password"
              [maxLength]="'120'"
              [isRequired]="true"
              type="password"></mobi-office-lib-input-field>
          </div>
          <div class="col-12 mt-2">
            <mobi-office-lib-input-field
              [(model)]="newPassword"
              [readOnly]="!USER_PROFILE_CONFIGURATION.canChangePassword"
              label="New Password"
              placeholder="New Password"
              [maxLength]="'120'"
              [isRequired]="true"
              type="password"></mobi-office-lib-input-field>
          </div>
          <div class="col-12 mt-2">
            <mobi-office-lib-input-field
              [(model)]="confirmPassword"
              label="Confirm Password"
              [readOnly]="!USER_PROFILE_CONFIGURATION.canChangePassword"
              placeholder="Confirm Password"
              [maxLength]="'120'"
              [isRequired]="true"
              type="password"></mobi-office-lib-input-field>
          </div>
          <div class="col-12 mt-3 d-flex justify-content-end">
            <button class="btn-md-filled-primary" matRipple (click)="onUpdatePassword()">Update</button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
<!-- <div mat-dialog-actions align="end">
  <button class="btn-md-outlined-error" matRipple [mat-dialog-close]="true">Close</button>
</div> -->
